const SectionTitle = ({ title, subtitle, align = 'center' }) => {
  const alignClass = align === 'left' ? 'text-left' : 'text-center';

  return (
    <div className={`mb-16 ${alignClass}`}>
      <h2 className="text-4xl md:text-5xl font-bold text-dark tracking-tight">
        {title}
      </h2>
      <div className="mt-4 w-16 h-1 bg-primary rounded-full mx-auto" style={align === 'left' ? { marginLeft: 0 } : {}} />
      {subtitle && (
        <p className="mt-6 text-lg text-dark/60 max-w-2xl leading-relaxed" style={align === 'center' ? { margin: '1.5rem auto 0' } : {}}>
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default SectionTitle;
